// Lightweight Web Audio helpers: monitor QRS beep + flatline alarm.

let ctx = null;
let gainMaster = null;
let muted = false;
let unlocked = false;

function ensure() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
    gainMaster = ctx.createGain();
    gainMaster.gain.value = 0.4;
    gainMaster.connect(ctx.destination);
  }
  return ctx;
}

export async function unlockAudio() {
  const c = ensure();
  if (!c) return false;
  try {
    if (c.state === "suspended") await c.resume();
    unlocked = true;
    return true;
  } catch {
    return false;
  }
}

export function isAudioUnlocked() {
  return unlocked;
}

export function setMuted(v) {
  muted = !!v;
  if (gainMaster) gainMaster.gain.value = muted ? 0 : 0.4;
}

export function isMuted() {
  return muted;
}

export function beep({ freq = 880, duration = 0.07 } = {}) {
  const c = ensure();
  if (!c || muted || !unlocked) return;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = "sine";
  osc.frequency.value = freq;
  g.gain.setValueAtTime(0.0001, c.currentTime);
  g.gain.exponentialRampToValueAtTime(0.6, c.currentTime + 0.005);
  g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + duration);
  osc.connect(g).connect(gainMaster);
  osc.start();
  osc.stop(c.currentTime + duration + 0.02);
}

let alarmOsc = null;
let alarmGain = null;

export function startAlarm() {
  const c = ensure();
  if (!c || muted || !unlocked) return;
  if (alarmOsc) return;
  alarmOsc = c.createOscillator();
  alarmGain = c.createGain();
  alarmOsc.type = "sawtooth";
  alarmOsc.frequency.value = 740;
  alarmGain.gain.value = 0.18;
  alarmOsc.connect(alarmGain).connect(gainMaster);
  alarmOsc.start();
}

export function stopAlarm() {
  if (alarmOsc) {
    try { alarmOsc.stop(); } catch { /* noop */ }
    alarmOsc.disconnect();
    alarmGain && alarmGain.disconnect();
    alarmOsc = null;
    alarmGain = null;
  }
}

export const qrsBeep = () => beep({ freq: 880, duration: 0.06 });

// Soft two-note chime for the medication hint (self-unlocks: called from a click).
export async function hintChime() {
  const c = ensure();
  if (!c || muted) return;
  if (!unlocked) await unlockAudio();
  if (!unlocked) return;
  [[660, 0], [990, 0.09]].forEach(([freq, at]) => {
    const osc = c.createOscillator();
    const g = c.createGain();
    osc.type = "triangle";
    osc.frequency.value = freq;
    const t0 = c.currentTime + at;
    g.gain.setValueAtTime(0.0001, t0);
    g.gain.exponentialRampToValueAtTime(0.35, t0 + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.22);
    osc.connect(g).connect(gainMaster);
    osc.start(t0);
    osc.stop(t0 + 0.25);
  });
}
